import { gql } from "apollo-boost";
import { openModal } from 'components/modal/modules/dispatcher/methods';
import { validateObjectId } from 'lib/utils/helpers';
import { RouteTo } from 'lib/utils/routing';
import CheckOut from 'pages/event/public/components/CheckOut';
import * as React from 'react';
import { Subscription } from "react-apollo";
import { withRouter } from 'react-router';
import { ClipLoader } from 'react-spinners';
import { injectStripe } from 'react-stripe-elements';
import { fetchGraphQL } from 'services/graphql/GraphQL';

import { purchase, purchaseFree } from '../../../components/graphql/queries/ticket';
import InternationalCardModal from './InternationalCardModal';


interface IDashboardOverviewProps {
  eventId: string;
  ticketCode?: string;
  token?: string;
  stripe?: {
    createToken: (options: any) => any;
    createCharge: (options: any) => any;
  };
  match?: any;
  code?: string;
  history?: any;
  dispatch?: any;
}

class EventPublicPage extends React.Component<
  IDashboardOverviewProps,
  { [label: string]: any }
  > {
  public state = {
    event: { id: "", fees: { absorb: true, perTicketFee: 0, perOrderFee: 0 } }, // initializing
    isLoading: true,
    charging: false,
    fullName: null,
    email: null,
    promoterId: null,
    purchaseError: false,
    errorMsg: "",
    internationalCard: false,
    updateString: 0,
    updateString1: 0
  };

  constructor(props) {
    super(props);
    this.createStripeChargeToken = this.createStripeChargeToken.bind(this);
    this.cleanError = this.cleanError.bind(this)
    this.resetCharging = this.resetCharging.bind(this)
    this.fetchNeededData = this.fetchNeededData.bind(this);
    this.reloadData = this.reloadData.bind(this);
  }

  public cleanError() {
    if (this.state.purchaseError !== false) {
      this.setState({ purchaseError: false })
    }
  }

  public reloadData(val: any, num: number) {
    this.fetchNeededData(val, num)
    return undefined;
  }

  public componentWillMount() {
    this.fetchNeededData(0, 0);
  }

  public fetchNeededData(val: any, num: any) {
    const { eventId, ticketCode } = this.props;
    if (ticketCode) {
      fetchGraphQL(
        `
          {
            event {
               get(eventId:"${eventId}") {
                  id
                  name
                  description
                  location
                  endTime
                  startTime
                  timezoneOffset
                  hosts
                  lastInitialOnly
                  onSale
                  isActive
                  hostName
                  currency
                  createdBy
                  capacityRemaining
                  links {
                    url
                    label
                  }
                  fees {
                    absorb
                    perTicketFee
                    perOrderFee
                    taxPercentage
                  }
                  privateTicket(ticketCode: "${ticketCode || ""}") {
                    ticketBankId
                    name
                    price
                    count
                    fee
                    description
                  }
                  styling{promoImg,bgImg,descripImg}
                  totalPrivate,
                  totalPublic,
                  configuration{
                    quota,
                    maxTicketsPerOrder
                    maxTicketsPerType
                  }
                }
              }
          }
        `
      ).then(result => {
        fetchGraphQL(

          `
            {
              ticket {
                get(ticketCode:"${ticketCode}") {
                  promoterId
                }		
              }
            }
          `
        ).then((value: any) => {
          if (value !== null && value.ticket) {
            if (result !== null) {
              const eventResult = result.event!.get;
              this.setState({
                event: eventResult ? eventResult : null,
                isLoading: false,
                promoterId: value.ticket.get.promoterId
              });
            } else {
              this.setState({
                isLoading: false,
                promoterId: value.ticket.get.promoterId
              });
            }
          } else {
            if (result !== null) {
              const eventResult = result.event!.get;
              this.setState({
                event: eventResult ? eventResult : null,
                isLoading: false
              });
            } else {
              this.setState({
                isLoading: false
              });
            }
          }
          if (num === 1) {
            this.setState({
              updateString: val
            })
          } else if (num === 2) {
            this.setState({
              updateString1: val
            })
          }
        });
      });
    } else if (validateObjectId(eventId)) {
      fetchGraphQL(
        `
          {
            event {
                  get(eventId:"${eventId}") {
                  id
                  name
                  description
                  location
                  endTime
                  startTime
                  timezoneOffset
                  isActive
                  creationTimeZone
                  hostName
                  currency
                  createdBy
                  onSale
                  lastInitialOnly
                  links {
                    url
                    label
                  }
                  configuration{
                    quota
                    maxTicketsPerOrder
                    maxTicketsPerType
                  }
                  publicTickets {
                    id
                    quantity
                    enabled
                    available
                    bought
                    price
                    name
                    goOnSaleAfter
                    description
                  }
                  publicTicketsAsString
                  fees {
                    absorb
                    perTicketFee
                    perOrderFee
                    taxPercentage
                  }
                  styling{promoImg,bgImg,descripImg}
                  revenueTotal
                  averageDayRevenue
                  boughtTotal
                  capacityRemaining
                }
              }
          }
        `
      ).then(result => {
        if (result !== null) {
          // console.log(result.event!.get.publicTickets)
          // console.log(JSON.parse(result.event!.get.publicTicketsAsString))
          const eventResult = { ...result.event!.get, publicTickets: JSON.parse(result.event!.get.publicTicketsAsString) };
          delete eventResult.publicTicketsAsString;
          this.setState({
            event: eventResult ? eventResult : null,
            isLoading: false
          });
        } else {
          this.setState({
            isLoading: false
          });
        }
        if (num === 1) {
          this.setState({
            updateString: val
          })
        } else if (num === 2) {
          this.setState({
            updateString1: val
          })
        }
      });
    }
  }

  public render() {
    if (this.state.isLoading) {
      return (
        <div
          className="p-3 w-100 text-center align-items-center align-content-center d-flex"
          style={{ minHeight: "100vh" }}
        >
          <div style={{ margin: "0 auto" }}>
            <ClipLoader color={"#000000"} loading={true} size={100} />
          </div>
        </div>
      );
    } else if (
      !this.state.isLoading &&
      this.state.event === null &&
      !validateObjectId(this.props.match.params.eventId)
    ) {
      return (
        <div
          className="p-3 w-100 text-center align-items-center align-content-center d-flex"
          style={{ minHeight: "100vh" }}
        >
          <div style={{ margin: "0 auto" }}>
            <h3>Event has not been found.</h3>
          </div>
        </div>
      );
    }

    const ticketInventoryUpdate = gql`
		subscription {
			updatedTicketInventory(eventId:"${this.props.match.params.eventId}")
		}
		`;

    const eventInformationUpdate = gql`
		subscription {
			eventDetailsUpdated(eventId:"${this.props.match.params.eventId}")
		}
    `;

    return (
      (
        <div className="div_holder_2" style={{ paddingTop: '25px' }}>
          <Subscription subscription={eventInformationUpdate}>
            {({ data }) => {
              if (data !== undefined && data !== null && data.eventDetailsUpdated !== null) {
                if (data.eventDetailsUpdated !== this.state.updateString1) {
                  return <img style={{ display: 'none' }} onLoad={this.reloadData(data.eventDetailsUpdated, 2)} />
                }
              }
              return null;
            }}
          </Subscription>
          {
            this.props.match.params.ticketCode ? null :
              <div>
                <Subscription subscription={ticketInventoryUpdate}>
                  {({ data }) => {
                    if (data !== undefined && data !== null && data.updatedTicketInventory !== null) {
                      if (data.updatedTicketInventory !== this.state.updateString) {
                        return <img style={{ display: 'none' }} onLoad={this.reloadData(data.updatedTicketInventory, 1)} />
                      }
                    }
                    return null;
                  }}
                </Subscription>
              </div>

          }
          <CheckOut
            {...this.state.event}
            promoterId={this.state.promoterId || null}
            ticketCode={this.props.match.params.ticketCode || null}
            createCharge={this.createStripeChargeToken}
            charging={this.state.charging}
            purchaseError={this.state.purchaseError}
            errorMsg={this.state.errorMsg}
            cleanError={this.cleanError}
            code={this.props.code ? this.props.code : ''}
            key={JSON.stringify(this.state.event)}
          />
        </div>
      ) || <div />
    );
  }

  public async createStripeChargeToken(formData: any, event: any, absorb?: boolean) {
    this.setState({ charging: true });
    const { isFree } = event;
    let purchaseResult: any = {};
    delete event.isFree;

    const ticketComponents: any[] = [];
    const ticketCode = event.code ? event.code : null;

    event.ticketComponents.map((item: any) => {
      if (item.count > 0) {
        ticketComponents.push(item);
      }
    });

    if (this.state.event.id === '5e8048057a3aa10ea99480bc' && formData.phoneNumber === '') {
      formData.phoneNumber = 'DONATION'
    } else if (formData.phoneNumber === '') {
      delete formData.phoneNumber;
    }

    const x = formData.emailConfirm;
    delete formData.emailConfirm;

    if (isFree) {
      ticketComponents.forEach(item => {
        delete item.price;
      });
      purchaseResult = await fetchGraphQL(purchaseFree(), undefined, {
        ticketComponents,
        ticketCode,
        eventId: this.state.event.id!,
        buyer: formData
      });
    } else {
      const token = await this.props.stripe!.createToken({
        name: formData.name
      });

      if (token.error) {
        this.setState({ charging: false });
      } else {
        // Currency conversion check
        if (token.token.card.country !== 'US') {
          if (absorb === true) {
            let subtotal = 0;
            ticketComponents.map(item => {
              subtotal += item.count * item.price
            })
            const extraCharge = subtotal * 0.01;
            ticketComponents.forEach(item => {
              delete item.price;
            });
            purchaseResult = await fetchGraphQL(purchase(), undefined, {
              ticketComponents,
              ticketCode,
              stripeToken: token.token.id,
              eventId: this.state.event.id!,
              buyer: formData,
              internationalCardConversionFee: String((extraCharge / 100).toFixed(2))
            });
          } else {
            openModal(
              <InternationalCardModal
                ticketComponents={ticketComponents}
                ticketCode={ticketCode}
                stripeToken={token.token.id}
                eventId={this.state.event.id}
                buyer={formData}
                resetCharging={this.resetCharging}
                {...this.state.event}
                promoterId={this.state.promoterId || null}
                createCharge={this.createStripeChargeToken}
                charging={this.state.charging}
                purchaseError={this.state.purchaseError}
                errorMsg={this.state.errorMsg}
                cleanError={this.cleanError}
              />,
              'International Card Detected');
            return;
          }

        } else {

          ticketComponents.forEach(item => {
            delete item.price;
          });

          purchaseResult = await fetchGraphQL(purchase(), undefined, {
            ticketComponents,
            ticketCode,
            stripeToken: token.token.id,
            eventId: this.state.event.id!,
            buyer: formData
          });
        }
      }
    }

    if (
      purchaseResult !== undefined &&
      purchaseResult.ticket !== undefined &&
      purchaseResult.ticket.purchase !== null &&
      purchaseResult.ticket.purchase !== 'PAYMENT_ERROR' &&
      purchaseResult.ticket.purchase !== 'NQUOTA' &&
      purchaseResult.ticket.purchase !== 'BOUGHT' &&
      purchaseResult.ticket.purchase !== 'NMATCH' &&
      purchaseResult.ticket.purchase !== 'RES_EMAIL' &&
      purchaseResult.ticket.purchase !== 'RISD' &&
      purchaseResult.ticket.purchase !== 'RISD2'
    ) {
      // Payment went through
      this.props.history.push(
        RouteTo.ticketPublic(purchaseResult.ticket.purchase)
      );
    } else {
      // Payment Error
      formData.emailConfirm = x;
      this.setState({
        purchaseError: true,
        errorMsg: purchaseResult.ticket.purchase || 'NMATCH',
        charging: false
      });
    }
    this.setState({ charging: false });
  }

  public resetCharging() {
    this.setState({ charging: false })
  }
}

export default withRouter(injectStripe(EventPublicPage));


// WEBPACK FOOTER //
// ./src/pages/event/public/Detail.page.tsx